import type { ActionTree, GetterTree, Module, MutationTree } from 'vuex';

/**
 * Module state
 */
interface State {
    caller: string;
    icon: string;
    smallIcon: string;
    footerLinks: any[] | null;
    footerCopyright: string;
    sessionId: string;
    sessionInfo: any | null;
}

const moduleState: State = {
    caller: '',
    icon: '',
    smallIcon: '',
    footerLinks: null,
    footerCopyright: '',
    sessionId: '',
    sessionInfo: null,
};

/**
 * Module getters
 */
const moduleGetters: GetterTree<State, any> = {
    caller(state: State) {
        return state.caller || '';
    },
    icon(state: State) {
        return state.icon || '../img/aprocon_logo-30.png';
    },
    smallIcon(state: State) {
        return state.smallIcon || '../img/icon-128-load.png';
    },
    footerLinks(state: State) {
        return state.footerLinks || null;
    },
    footerCopyright(state: State) {
        return state.footerCopyright || '';
    },
    sessionId(state: State) {
        return state.sessionId || '';
    },
    sessionInfo(state: State) {
        return state.sessionInfo || null;
    }
};

/**
 * Module mutations
 */
const moduleMutations: MutationTree<State> = {
    setCaller(state: State, caller: string) {
        state.caller = caller;
    },
    setIcon(state: State, icon: string) {
        state.icon = icon;
    },
    setSmallIcon(state: State, smallIcon: string) {
        state.smallIcon = smallIcon;
    },
    setFooterLinks(state: State, links: any[]) {
        state.footerLinks = links;
    },
    setFooterCopyright(state: State, copyright: string) {
        state.footerCopyright = copyright;
    },
    setSessionId(state: State, sessionId: string) {
        state.sessionId = sessionId;
    },
    setSessionInfo(state: State, sessionInfo: any) {
        state.sessionInfo = sessionInfo;
    },
};

/**
 * Module actions
 */
const moduleActions: ActionTree<State, any> = {

};

/**
 * Construct Module
 */
const module: Module<State, any> = {
    namespaced: true,
    state: moduleState,
    getters: moduleGetters,
    mutations: moduleMutations,
    actions: moduleActions,
};
export default module;
